import './App.css';
import React, { useState } from "react";
import MUIDataTable from "mui-datatables";
import axios from "axios";
import { api } from "./api/client";
import { ThemeProvider, createTheme, adaptV4Theme } from '@mui/material/styles';
import Button from '@mui/material/Button';
import IconButton from "@mui/material/IconButton";
import { Dialog, DialogActions, DialogContent, DialogTitle, TextField, MenuItem, Switch, FormControlLabel } from "@material-ui/core";
import { DeleteForever } from "@material-ui/icons";
import EditIcon from '@material-ui/icons/Edit';
import { saveAs } from 'file-saver'
import { write, utils } from 'xlsx'
import moment from "moment/moment";
import VizeKayitForm from "./Components/VizeKayitForm";
import {Autocomplete} from "@mui/material";
import { enhanceColumns, withTableOptions } from "./utils/tableDisplay";
const KayitTuruOptions = ['Schengen', 'ABD', 'İngiltere'];
const VizeTuruOptions = ['MULTI', 'SINGLE'];

class VizeListesi extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            datas: [],
            editDialogOpen: false,
            deleteDialogOpen: false,
            selectedRow: null,
            id: "",
            personeller:[],
         };
    }

    componentDidMount() {
        this.getDatas();
        this.getPersoneller();
    }

    async getDatas() {
        const res = await api.get('/vizeler');
        const data = res.data.data.map(d => ({
            id: d.id,
            personal_id: d.personal_id,
            isim: d.isim,
            baslangic_tarihi: d.baslangic,
            bitis_tarihi: d.bitis,
            kayit_turu: d.kayit_turu,
            vize_turu: d.vize_turu,
            sigorta: d.sigorta,
            note:d.note,
            passport_no: d.passport_no,
            gun_sayisi:d.gun_sayisi,

        }));
        this.setState({ datas: data });
    }

    handleEditClick = (rowData) => {
        this.setState({ selectedRow: { ...rowData }, editDialogOpen: true });
    }

    handleFieldChange = (e) => {
        const { name, value, type, checked } = e.target;
        this.setState(prevState => ({
            selectedRow: {
                ...prevState.selectedRow,
                [name]: type === 'checkbox' ? (checked ? 1 : 0) : value
            }
        }));
    }

    handleUpdate = async () => {
        const r = this.state.selectedRow;
        await api.patch('/vizeler/' + r.id, {
            baslangic: r.baslangic_tarihi,
            bitis: r.bitis_tarihi,
            kayit_turu: r.kayit_turu,
            vize_turu: r.vize_turu,
            sigorta: r.sigorta,
            note: r.note,
            passport_no: r.passport_no,
            gun_sayisi: r.gun_sayisi,
        }).then((response) => {console.log('başarılı')}).catch((error) => {console.log(error)});
        this.setState({ editDialogOpen: false });
         this.getDatas();
    }
    async getPersoneller() {
        const res = await api.get('/lookups/users', { params: { scope: 'liste' } });
        this.setState({ personeller: res.data });
    }


    handleDeleteVize = async (id, correct) => {
        await api.delete('/vizeler/' + id)
            .then((response) => {
                // Success 🎉
                console.log('sildini', response)
                window.location.reload()
            })
            .catch((error) => {
                // Error 😨
                if (error.response) {
                    /*
                     * The request was made and the server responded with a
                     * status code that falls out of the range of 2xx
                     */
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                } else if (error.request) {
                    /*
                     * The request was made but no response was received, `error.request`
                     * is an instance of XMLHttpRequest in the browser and an instance
                     * of http.ClientRequest in Node.js
                     */
                    console.log(error.request);
                } else {
                    // Something happened in setting up the request and triggered an Error
                    console.log('Error', error.message);
                }
                console.log(error.config);
            });

    }

    render() {
        const options = {
            filter: true,
            onFilterChange: (changedColumn, filterList) => {
                console.log(changedColumn, filterList);
            },

            selectableRows: 'none',
            filterType: 'multiselect',
            responsive: "vertical",
            rowsPerPage: 100,
            fixedHeader: true,
            //fixedSelectColumn: true,
            tableBodyHeight: '100%',
            print:false,
            download:true,
            searchOpen:false,
            draggableColumns: {
                enabled:false,
                transitionTime:400
            },
            rowStyle: {
                fontSize: 9,
                lineHeight:0.1
            },
            downloadOptions: {
                filterOptions: {
                    useDisplayedColumnsOnly: true,
                    useDisplayedRowsOnly: true
                }
            },

            textLabels :{
                body: {
                    noMatch: "Bu tabloda hiç bir veri yok",
                    toolTip: "Sırala",
                    columnHeaderTooltip: column => `${column.label} için sırala`
                },
                selectedRows: {
                    text: "satır seçildi",
                    delete: "SiparişeEkle",
                    deleteAria: "Seçilenleri siparişe aktar",
                },
                pagination: {
                    next: "İleri",
                    previous: "Geri",
                    rowsPerPage: "Sayfadaki satır sayısı:",
                    displayRows: "/",
                },
                toolbar: {
                    search: "Ara",
                    downloadCsv: "XLSX İndir",
                    print: "Çıktı Al",
                    viewColumns: "Sütunları Göster",
                    filterTable: "Tabloyu Süz",
                },
                filter: {
                    all: "Tümünü Göster",
                    title: "Filtreler",
                    reset: "Sıfırla",
                },
                viewColumns: {
                    title: "Sütunları Göster",
                    titleAria: "Sütunları Göster/Gizle",
                },

            },
            onDownload: (buildHead, buildBody, columns, values) => {
                const fileType =
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
                const fileExtension = ".xlsx";

                console.log(values.forEach(val => console.log(val)));

                const json = values.reduce((result, val) => {
                    const temp = {};
                    val.data.forEach((v, idx) => {
                        temp[columns[idx].name] = v;
                    });
                    result.push(temp);
                    return result;
                }, []);

                const fileName = `Taslak İş Emirleri Listesi`;
                const ws = utils.json_to_sheet(json);
                const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
                const excelBuffer = write(wb, { bookType: "xlsx", type: "array" });
                const data = new Blob([excelBuffer], { type: fileType });
                saveAs(data, fileName + fileExtension);
                // cancel default  CSV download from table
                return false;
            },

        };

        const columns = [
            {
                name: "id",
                label: "Düzenle",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRender: (value, tableMeta) => {
                        const rowData = this.state.datas[tableMeta.rowIndex];
                        return (
                            <IconButton onClick={() => this.handleEditClick(rowData)}>
                                <EditIcon />
                            </IconButton>
                        );
                    }
                }
            },
            {
                name: "id",
                label: "Sil",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRender: (value) => (
                        <IconButton size="small" onClick={() => this.setState({ deleteDialogOpen: true, id: value })} color="error">
                            <DeleteForever />
                        </IconButton>
                    )
                }
            },
            { name: "personal_id", label: "Personel ID", options: {
                    filter: false,
                    sort: false,

                }
            },
            { name: "isim", label: "İsim - Soyisim",
            options: {     filterOptions: {
                    fullWidth: true
                },}

            },
            { name: "passport_no", label: "Pasaport No",
                options: {     filterOptions: {
                    filter:false,
                        fullWidth: false
                    },}

            },
            { name: "sigorta", label: "Kayıt Türü",
                options: {     filterOptions: {
                        fullWidth: true
                    },}

            },
            { name: "kayit_turu", label: "Vize Bölgesi" ,
                options: {     filterOptions: {
                        fullWidth: true
                    },}

            },
            { name: "vize_turu", label: "Vize Türü" ,
                options: {     filterOptions: {
                        fullWidth: true
                    },}
            },
            { name: "gun_sayisi", label: "Gün Sayısı" ,
                options: {     filterOptions: {
                    filter: false,
                        fullWidth: false
                    },}
            },
            { name: "baslangic_tarihi", label: "Başlangıç Tarihi", options: {
                    filter: false,
                    sort: true,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        if (value) {
                            return (
                                moment(new Date(value)).format('DD/MM/yyyy')
                            );

                        }
                    },


                } },
            { name: "bitis_tarihi", label: "Bitiş Tarihi" , options: {
                    filter: false,
                    sort: true,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        if (value) {
                            return (
                                moment(new Date(value)).format('DD/MM/yyyy')
                            );

                        }
                    },}},
            { name: "note", label: "Notlar" , options: {
                    filter: false,
                    sort: false,

                    }}
        ];


        const theme = createTheme(adaptV4Theme({}));

        return (
            <>
            <VizeKayitForm />
            <ThemeProvider theme={theme}>

                <MUIDataTable title={"Vize Listesi"} data={this.state.datas} columns={enhanceColumns(columns)} options={withTableOptions(options)} />

                <Dialog open={this.state.editDialogOpen} onClose={() => this.setState({ editDialogOpen: false })} fullWidth>
                    <DialogTitle>Kayıt Düzenle</DialogTitle>
                    <DialogContent>
                        <Autocomplete
                            options={this.state.personeller}
                            getOptionLabel={(option) => `${option.isim} ${option.soyisim}`}
                            value={
                                this.state.personeller.find(p => p.id === this.state.selectedRow?.personal_id) || null
                            }
                            onChange={this.handleFieldChange}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Personel"
                                    margin="normal"
                                    fullWidth
                                />
                            )}
                        />
                        <TextField
                            fullWidth
                            margin="normal"
                            label="Pasaport No"
                            name="passport_no"
                            value={this.state.selectedRow?.passport_no || ''}
                            onChange={this.handleFieldChange}
                        />
                        <TextField
                            label="Başlangıç Tarihi"
                            type="date"
                            name="baslangic_tarihi"
                            value={this.state.selectedRow?.baslangic_tarihi || ''}
                            onChange={this.handleFieldChange}
                            fullWidth
                            margin="normal"
                            InputLabelProps={{ shrink: true }}
                        />
                        <TextField
                            label="Bitiş Tarihi"
                            type="date"
                            name="bitis_tarihi"
                            value={this.state.selectedRow?.bitis_tarihi || ''}
                            onChange={this.handleFieldChange}
                            fullWidth
                            margin="normal"
                            InputLabelProps={{ shrink: true }}
                        />
                        <TextField
                            select
                            label="Vize Bölgesi"
                            name="kayit_turu"
                            value={this.state.selectedRow?.kayit_turu || ''}
                            onChange={this.handleFieldChange}
                            fullWidth
                            margin="normal"
                        >
                            {KayitTuruOptions.map(option => (
                                <MenuItem key={option} value={option}>{option}</MenuItem>
                            ))}
                        </TextField>
                        <TextField
                            fullWidth
                            select
                            margin="normal"
                            label="Vize Türü"
                            name="vize_turu"
                            value={this.state.selectedRow?.vize_turu || ''}
                            onChange={this.handleFieldChange}
                        >
                            {VizeTuruOptions.map((option) => (
                                <MenuItem key={option} value={option}>{option}</MenuItem>
                            ))}
                        </TextField>
                        <TextField
                            fullWidth
                            margin="normal"
                            label="Gun"
                            name="gun_sayisi"
                            value={this.state.selectedRow?.gun_sayisi || ''}
                            onChange={this.handleFieldChange}
                        >

                        </TextField>
                        <TextField
                            label="Notlar"
                            name="note"
                            value={this.state.selectedRow?.note || ''}
                            onChange={this.handleFieldChange}
                            fullWidth
                            margin="normal"
                        >

                        </TextField>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={this.state.selectedRow?.sigorta === 'Sigorta'}
                                    onChange={(e) =>
                                        this.setState(prev => ({
                                            selectedRow: {
                                                ...prev.selectedRow,
                                                sigorta: e.target.checked ? "Sigorta" :"Vize"
                                            }
                                        }))
                                    }
                                />
                            }
                            label="Sigorta"
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => this.setState({ editDialogOpen: false })}>İptal</Button>
                        <Button onClick={this.handleUpdate} variant="contained">Güncelle</Button>
                    </DialogActions>
                </Dialog>
                {/*vise silme dialog başlangıcı*/}
                <Dialog
                    open={this.state.deleteDialogOpen}
                    onClose={()=>{this.setState({deleteDialogOpen:false})}}
                    aria-labelledby="form-dialog-title"
                    maxWidth="md"
                >
                    <DialogTitle id="form-dialog-title">Vizeyi Tamamen Sil</DialogTitle>
                    <DialogContent>
                        Onaylıyor musunuz?
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={()=>{this.setState({deleteDialogOpen:false})}} color="primary">
                            İptal
                        </Button>
                        <Button

                            onClick={ ()=>{ this.handleDeleteVize(this.state.id, true) }}
                            color="primary"
                        >
                            Sil
                        </Button>
                    </DialogActions>
                </Dialog>
            </ThemeProvider></>
        );
    }
}

export default VizeListesi;